import { Editor } from "react-draft-wysiwyg";
import styles from "./code-editor.module.scss";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import PreviewIcon from "src/assets/icons/preview.svg?react";
import { ContentState, EditorState, convertFromHTML } from "draft-js";
import { useEffect, useState } from "react";
import Button from "../button/Button";

export default function CodeEditor(props: any) {
  const defaultUrl = "";
  const splitor = `<!-- <next/> -->`;

  const getHeadCode = () => {
    if (props.data.indexOf(splitor) > -1) {
      // include head code
      const codes = props.data.split(splitor);
      return ContentState.createFromText(codes[0]);
    } else {
      return ContentState.createFromText("");
    }
  };
  const getBodyCode = () => {
    if (!props.data) {
      return ContentState.createFromText("");
    }
    if (props.data.indexOf(splitor) > -1) {
      // include head code
      const codes = props.data.split(splitor);
      return ContentState.createFromText(codes[1]);
    } else {
      return ContentState.createFromText(props.data);
    }
  };
  const [head, setHead] = useState(() =>
    EditorState.createWithContent(
      props.data ? getHeadCode() : ContentState.createFromText("")
    )
  );
  const [body, setBody] = useState(() =>
    EditorState.createWithContent(
      props.data ? getBodyCode() : ContentState.createFromText("")
    )
  );
  const [url, setUrl] = useState(() =>
    EditorState.createWithContent(
      props.url
        ? ContentState.createFromText(
            props.url.replace("Content description", "")
          )
        : ContentState.createFromBlockArray(
            convertFromHTML(defaultUrl).contentBlocks
          )
    )
  );

  const setCodeSection = () => {
    if (!props.data || props.data === "") {
      setHead(EditorState.createWithContent(ContentState.createFromText("")));
      setBody(EditorState.createWithContent(ContentState.createFromText("")));
      return;
    }
    if (props.data.indexOf(splitor) > -1) {
      // include head code
      const codes = props.data.split(splitor);
      setHead(
        EditorState.createWithContent(ContentState.createFromText(codes[0]))
      );
      setBody(
        EditorState.createWithContent(ContentState.createFromText(getFilteredString(codes[1])))
      );
    } else {
      setHead(EditorState.createWithContent(ContentState.createFromText("")));
      setBody(
        EditorState.createWithContent(ContentState.createFromText(getFilteredString(props.data)))
      );
    }
  };

  useEffect(() => {
    setCodeSection();

    if (props.lessonType) {
      if (props.data && props.data.indexOf('<!--<description>') > -1) {
        const temp = props.data.split('<!--<description>')
        temp[1] && setUrl(
          EditorState.createWithContent(
            ContentState.createFromText(
              temp[1].replace("</description>-->", "").replace('<!--', "")
            )
          )
        );
      }  else {
        setUrl(
          EditorState.createWithContent(
            ContentState.createFromText("")
          )
        );
      }
    } else if (props.url) {
      setUrl(
        EditorState.createWithContent(
          ContentState.createFromText(
            props.url.replace("Content description", "")
          )
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data]);

  const onSetData = () => {
    let raw =
    head.getCurrentContent().getPlainText() +
    splitor +
    body.getCurrentContent().getPlainText();
    if (props.lessonType) {
      const rawURl = url.getCurrentContent().getPlainText();
      if (rawURl) {
        const path = raw.indexOf("<!--<description>");

        if (path !== -1) {
          const subString = raw.substring(path, raw.length);
          raw = raw.replace(subString, '')
        }
        raw = raw + `<!--<description>${rawURl}</description>-->`
      }
    } else {
      onSetURL();
    }
    if (raw) {
      props.onSetData(raw);
    }
  }

  useEffect(() => {
    if (head || body || url) {
      onSetData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [head, body, url])

  const onURLChange = (state) => {
    setUrl(state);
    onSetURL()
  };

  const getFilteredString = (raw) => {
    const path = raw.indexOf("<!--<description>");

    if (path !== -1) {
      const subString = raw.substring(path, raw.length);
      raw = raw.replace(subString, '')
    }
    return raw;
  }

  const onSubmit = () => {
    let raw =
    head.getCurrentContent().getPlainText() +
    splitor +
    body.getCurrentContent().getPlainText();
    if (props.lessonType) {
      const rawURl = url.getCurrentContent().getPlainText();
      if (rawURl) {
        const path = raw.indexOf("<!--<description>");

        if (path !== -1) {
          const subString = raw.substring(path, raw.length);
          raw = raw.replace(subString, '')
        }
        raw = raw + `<!--<description>${rawURl}</description>-->`
      }
    } else {
      onSetURL();
    }
    if (raw) {
      props.onSubmit(raw);
    }
  };

  const onSetURL = () => {
    const rawURl = url.getCurrentContent().getPlainText();
    if (rawURl && props.onSetUrl) {
      props.onSetUrl(rawURl);
    }
  }

  const onPreview = () => {
    const rawURl = url.getCurrentContent().getPlainText();
    if (rawURl && rawURl.indexOf("http") > -1) {
      const link = rawURl.split(" ").find((word) => word.startsWith("http"));
      window.open(link);
    }
  };

  const isPreviewDisabled = !body.getCurrentContent().getPlainText();

  const isPreviewLinkDisabled =
    !url.getCurrentContent().getPlainText() ||
    url.getCurrentContent().getPlainText().indexOf("http") === -1;

  return (
    <div className={styles.flexColumn}>
      <div className={styles.labelContainer}>
        <label className={styles.label}>Paste Slides.com Code</label>
        <Button
          outline={true}
          color="orange"
          label={"PREVIEW SLIDE"}
          size={"tiny"}
          className={isPreviewDisabled ? styles.disabled : ""}
          disabled={isPreviewDisabled}
          onClick={onSubmit}
        />
      </div>
      <div className={styles.flexRow}>
        <Editor
          editorState={url}
          onEditorStateChange={onURLChange}
          toolbarHidden
          editorClassName={styles.revealURLEditor}
          placeholder="Slides.com Lesson URL"
        />

        <button
          className={
            isPreviewLinkDisabled
              ? `${styles.previewBtn} ${styles.disabled}`
              : ""
          }
          onClick={onPreview}
          disabled={isPreviewLinkDisabled}
        >
          <PreviewIcon />
        </button>
      </div>

      <Editor
        editorState={head}
        onEditorStateChange={setHead}
        toolbarHidden
        editorClassName={styles.revealCodeEditor}
        placeholder="Paste Slides.com <Head> Code here"
      />
      <Editor
        editorState={body}
        onEditorStateChange={setBody}
        toolbarHidden
        editorClassName={styles.revealCodeEditor}
        placeholder="Paste Slides.com <Body> Code here"
      />
    </div>
  );
}
